import { getPath, getInitialState } from "../../utils";

const initialState = {
  zoneList: [],
  prevPage: -1,
  nextPage: -1,
  currentPage: 1,
  activeZone: {},
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_ZONE_LIST":
      return setZoneList(state, action);
    case "SET_ACTIVE_ZONE":
      return setActiveZone(state, action);
    case "SET_CURRENT_PAGE_ZONE":
      return setCurrentPageZone(state, action);
    case "SET_ACTIVE_ZONE_FILTERS":
      return setActiveZoneFilters(state, action);
    case "RESET_STATE_ZONE":
      return resetState(state, action);
    default:
      return state;
  }
}

const setActiveZone = (state, action) => {
  return {
    ...state,
    activeZone: action.payload,
  };
};

const setZoneList = (state, action) => {
  return {
    ...state,
    zoneList: getPath(action.payload, "zones", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const setCurrentPageZone = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setActiveZoneFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
